var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"1em","height":"1em","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M21.2 10.5L8.6 3.2c-1-.6-2.6 0-2.6 1.5v14.6c0 1.3 1.5 2.1 2.6 1.5l12.6-7.3a1.7 1.7 0 000-3z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }